import React, { Fragment, useEffect, useRef, useState } from 'react'
import { ErrorMessage, Field } from 'formik';
import classNames from 'classnames';
import "./styles/MultiSelect.scss";
import MultiSelectOption from './components/MultiSelectOption';
import MultiSelectOptions from './components/MultiSelectOptions';
import useClickOutside from 'scenes/ProjectMultiStepForm/hooks/useClickOutside';
import { useStateMachine } from 'little-state-machine';

const MultiSelect = ({
  config,
  className,
  isOnlyOneOption,
  updateField,
  onFilterChange,
  handlerCreateProvider,
  withoutCreateProvider
}) => {
  const { name, initialValues, selectValues, disabled, disabledPlaceholder, placeholderMessage } = config;
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(initialValues || []);
  const { elementRef } = useClickOutside(setShowDropdown);
  const { state } = useStateMachine();

  const handleShowDropdown = () => {
    if (!disabled) setShowDropdown(true);
  };

  const handleClickCurrentOption = (clickedOption) => (e) => {
    e.stopPropagation();
    
    /* Only one option */
    if (isOnlyOneOption) {
      setShowDropdown(false);
      setSelectedOptions([clickedOption]);
      updateField(name, [clickedOption]);
      return;
    }
  };

  const handleDeleteOption = (clickedOption) => (e) => {
    e.stopPropagation();

    /* Only one option */
    if (isOnlyOneOption) {
      setSelectedOptions([]);
      updateField(name, []);
      return;
    }
  }

  useEffect(() => {
    if (Array.isArray(initialValues) && initialValues.length > 0) {
      setSelectedOptions(initialValues);
    }
  }, [initialValues]);
  
  return (
    <Fragment>
      <div
        ref={elementRef}
        className={classNames({
          "bg-transparent": !disabled,
          "disabled-select": disabled,
          "custom-select multi-select form-control position-relative": true,
          [className]: true,
        })}
        onClick={handleShowDropdown}
      >
        <div className="multi-select__default-option d-flex">
          {selectedOptions.length > 0 ? (
            selectedOptions.map((option, index) => (
              <MultiSelectOption
                key={index}
                currentOption={option}
                handleClickInDeleteOption={handleDeleteOption}
              />
            ))
          ) : (
            <span className="multi-select__placeholder">
              {disabled
                ? disabledPlaceholder
                : placeholderMessage}
            </span>
          )}
        </div>
        {showDropdown && selectValues && (
          <MultiSelectOptions
            selectedOptions={selectedOptions}
            selectValues={selectValues}
            loading={disabled}
            disabledPlaceholder={disabledPlaceholder}
            handleClickCurrentOption={handleClickCurrentOption}
            onFilterChange={onFilterChange}
            handlerCreateProvider={handlerCreateProvider}
            withoutCreateProvider={withoutCreateProvider}
          />
        )}
        <Field
          id={name}
          name={name}
          component="select"
          className="select--field"
        />
      </div>
      <ErrorMessage
        className="form-error-message"
        component="div"
        name={name}
      />
    </Fragment>
  );
}

MultiSelect.defaultProps = {
  config: {
    name: "",
    initialValues: [],
    selectValues: [],
    disabled: false,
    placeholderMessage: "",
  },
  isOnlyOneOption: false,
  updateField: () => {},
  onFilterChange: () => {},
}

export default MultiSelect;